// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"cd1ec635","513":"0dd063f0","703":"69f1a70c","787":"06c578ed"}[chunkId] + ".chunk.js";
};